// extracted by mini-css-extract-plugin
export var emptyState = "_6i-d";
export var statCard = "_6i-c";
export var table = "_6i-0";
export var tableCell = "_6i-4";
export var tableCellClickable = "_6i-5 _6i-4";
export var tableCellDefault = "_6i-6 _6i-4";
export var tableCellEmpty = "_6i-8";
export var tableCellWithValue = "_6i-7";
export var tableContainer = "_6i-e";
export var tableHeaderWeight = "_6i-1";
export var tableHeaderZone = "_6i-2";
export var tableRowHeader = "_6i-3";
export var viewModeButton = "_6i-9";
export var viewModeButtonActive = "_6i-a _6i-9";
export var viewModeButtonInactive = "_6i-b _6i-9";